import Marquee from "react-fast-marquee";

const donors = [
  {
    name: "Mizzou",
    src: "/images/donors/mizzou.png",
    href: "https://missouri.edu/",
    keepColor: true,
  },
  {
    name: "Mizzou College of Engineering",
    src: "/images/donors/mizzou_engineering.png",
    href: "https://engineering.missouri.edu/",
    keepColor: true,
  },
  {
    name: "SolidWorks",
    src: "/images/donors/solidworks.png",
    href: "https://www.solidworks.com/",
  },
  {
    name: "MathWorks",
    src: "/images/donors/mathworks.png",
    href: "https://www.mathworks.com/",
  },
  {
    name: "Blue Robotics",
    src: "/images/donors/bluerobotics.png",
    href: "https://bluerobotics.com/",
  },
  {
    name: "NVIDIA",
    src: "/images/donors/nvidiaBlackAndWhite.png",
    href: "https://www.nvidia.com/en-us/",
  },
  {
    name: "Garmin",
    src: "/images/donors/garmin-logo.png",
    href: "https://www.garmin.com/en-US/",
  },
  {
    name: "Veterans United Home Loans",
    src: "/images/donors/veteransunited.png",
    href: "https://www.veteransunited.com/",
  },
];

const Donors = () => {
  return (
    <div id="donors" className="donors-section">
      <h3 className="donors-heading">Our Donors</h3>
      <Marquee gradient={false} speed={40} pauseOnHover>
        {donors.map((d) => (
          <a
            key={d.name}
            href={d.href}
            target="_blank"
            rel="noreferrer"
            className="donor-item"
          >
            <img
              src={d.src}
              alt={d.name}
              className={`donor-logo${d.keepColor ? " donor-logo--color" : ""}`}
              loading="lazy"
            />
          </a>
        ))}
      </Marquee>
      <p className="donors-cta">
        Want to help support our team? Contact us above to donate or find more
        ways to help!
      </p>
    </div>
  );
};

export default Donors;
